import React from "react";
import cx from "classnames";
import ReactSVG from "react-svg";

import "./styles.scss";

const ErrorField = ({ meta }) => {
    if (!meta) return null;
    const { error, touched } = meta;
    if (!error || !touched) return null;

    return <div className="error-info">{error}</div>;
};

const getLabel = (label, required) => {
    if (!label) return null;

    return (
        <div className="input-label">
            {label}
            {required && <span className="required-field">*</span>}
        </div>
    );
};

const CheckBox = props => {
    const { label, disabled, required, input, meta, className, ...rest } = props;
    const containerClassName = cx(
        "input-element-checkbox input-element",
        { "input-element__error": meta && meta.touched && !meta.valid, disabled },
        className
    );

    function handleChange(e) {
        const currentValue = Boolean(input ? input.value : props.value);
        if (input && input.onChange && typeof input.onChange === "function") {
            input.onChange(!currentValue);
        }
        if (props.onChange && typeof props.onChange === "function") {
            props.onChange(!currentValue);
        }
    }
    return (
        <div className={containerClassName}>
            <label className="input-element-checkbox-wrapper">
                <input
                    type="checkbox"
                    checked={Boolean(input ? input.value : props.value)}
                    disabled={disabled}
                    {...input}
                    {...rest}
                    onChange={handleChange}
                />

                <div className="check-mark">
                    <ReactSVG className="checkbox__unchecked-icon" src={`/data/svg/checkbox_unchecked.svg`} />
                    <ReactSVG className="checkbox__checked-icon" src={`/data/svg/checkbox_checked.svg`} />
                </div>
                {getLabel(label, required)}
            </label>
            <ErrorField meta={meta} />
        </div>
    );
};

export default CheckBox;
